import { send } from 'server';
export * from 'js/components/main/QuickDeposit/actions';

export const getPaymentMethodAccounts = data => send({
    hideAccountsWithoutInfo: false,
    ...data,
    ID: 33011,
    responses: [33012, 33013],
    description: 'Get payment method accounts'
});
